import { render, staticRenderFns } from "./CarGasolineList.vue?vue&type=template&id=f2f50f96&scoped=true&"
import script from "./CarGasolineList.vue?vue&type=script&lang=js&"
export * from "./CarGasolineList.vue?vue&type=script&lang=js&"
import style0 from "./CarGasolineList.vue?vue&type=style&index=0&id=f2f50f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f50f96",
  null
  
)

export default component.exports